import { useCallback } from "react";
import { useInterval, useLatest } from "react-use";

export function useTimeout(end: number | null, callback: () => void) {
  const endRef = useLatest(end);
  const callbackRef = useLatest(callback);

  const checkTimeout = useCallback(() => {
    const now = Date.now();
    const endsAt = endRef.current;

    if (endsAt != null && endsAt <= now) {
      callbackRef.current();
    }
  }, [callbackRef, endRef]);

  // schedule interval to check timeout every second
  useInterval(checkTimeout, 1000);
}
